import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { ContextMenuItem } from '../../../../../../components';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { selectorContextMenu } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { selectorDataPointsExhibitionType } from '../../../../../../reducers/gerenciadorPrecos/datapointExhibitionType';
import { PriceCompositionData, SET_DATA, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/priceComposition';
import { getPriceComposition } from '../../../services';
import { getDataModalComposition } from '../../ComposicaoPrecoModal';

type PriceCompositionContextMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const PriceCompositionContextMenu = ({ contextMenuDatapoint, openModal, setData, datapointExhibitionType }: PriceCompositionContextMenuProps) => {
  const handleOpenPriceCompositionModal = async () => {
    if (!contextMenuDatapoint) throw new Error('Erro ao buscar datapoint.');

    const model = {
      productId: contextMenuDatapoint.productId,
      storeId: contextMenuDatapoint.storeId,
      clusterId: contextMenuDatapoint.clusterId,
      datapointExhibitionType,
    };

    try {
      const response = await getPriceComposition(model);

      if (!response) throw new Error('Erro ao buscar composição de preços.');

      const parsedResponse = getDataModalComposition(response);

      setData(parsedResponse);

      openModal();
    } catch (err) {
      throw AlertWithTimestamp({ message: err.message });
    }
  };

  return <ContextMenuItem onClick={handleOpenPriceCompositionModal}>Composição do preço</ContextMenuItem>;
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
  datapointExhibitionType: selectorDataPointsExhibitionType(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openModal: () => dispatch(SET_IS_OPEN(true)),
  setData: (payload: PriceCompositionData[] | null) => dispatch(SET_DATA(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceCompositionContextMenu);
